<script setup lang="ts">
import { inject, onMounted }         from "vue";
import { MainCarousel }              from "@TsUtils/MainCarousel";
import Card                          from "@ViewCommonComponents/Card.vue";
import type { TypeReviewsDataItems } from "@ViewPages/Main/Components/commonTypes";

type TypeProps = {
    reviews_data : TypeReviewsDataItems,
    device_type : string,
};

const props = <TypeProps>inject('reviews_data'),
    isMobileDevice = props?.device_type == 'mobile';

const mainCarousel = new MainCarousel({
    idOrClassNameCarouseEl: '#reviews-items-carousel',
    idOrClassNameCarouselItemsEls: '#reviews-items-carousel-item-',
    idOrClassNameIndicatorEls: '#reviews-items-carousel-indicator-',
    data_list: props?.reviews_data.reviews_list,
    isMobileDevice: isMobileDevice,
});

onMounted(() => {
    if (isMobileDevice) {
        mainCarousel.handleCarousel();
    }
});

const carouselItemClass = [
        isMobileDevice
            ? 'hidden duration-200 ease-linear'
            : 'w-30% lg:w-1/4 xl-6:w-30% min-h-[486px]',
        'min-w-80',
    ].join(' '),
    carouselWrapperClass = [
        isMobileDevice ? 'max-sm:h-510px h-400px' : 'flex flex-wrap max-lg:justify-evenly justify-between gap-x-4 gap-y-14'
    ].join(' ');
</script>

<template>
    <div class="reviews__item">
        <div class="relative w-full overflow-hidden" id="reviews-items-carousel">
            <!-- Carousel wrapper -->
            <div :class="carouselWrapperClass">
                <!-- Item -->
                <div v-for="(data, index) in props?.reviews_data.reviews_list"
                     :key="index" :id="'reviews-items-carousel-item-' + (+index + 1)"
                     :class="[carouselItemClass]"
                     @touchstart="mainCarousel.handleTouchStart"
                     @touchend="mainCarousel.handleTouchEnd"
                     @touchmove="mainCarousel.handleTouchMove">

                    <Card :card-classes="isMobileDevice ? 'w-full' : 'max-w-[450px] h-full'"
                          v-bind="data"
                          :is-need-btn="false"
                          description-classes="mb-30px xl-6:mb-69px"></Card>
                </div>
            </div>

            <!-- Slider indicators -->
            <div v-if="isMobileDevice"
                 class="absolute z-30 flex -translate-x-1/2 space-x-3 bottom-3 left-1/2">
                <button type="button" class="w-3 h-3 rounded-full" v-for="index in Object.keys(props?.reviews_data.reviews_list)"
                        :aria-current="+index == 0"
                        :aria-label="'Slide' + index"
                        :id="'reviews-items-carousel-indicator-' + (+index + 1)"
                ></button>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
